export default __webpack_public_path__ + "static/media/kitchen3-afterF.bdcea042.jpg";